export default function UserAvatar({ user, style = {}, textStyle }) {
  return (
    <div
      className="avatar rounded-full"
      style={{
        backgroundColor:
          user?.user_avatar &&
          user?.user_avatar !==
            "https://api.wpsitelauncher.com/assets/default-avatar.png"
            ? "white"
            : 'var(--theme-blue)',
        ...style,
      }}
    >
      {user?.user_avatar &&
      user?.user_avatar !==
        "https://api.wpsitelauncher.com/assets/default-avatar.png" ? (
        <img
          src={user.user_avatar}
          className="rounded-full bg-transparent"
          alt={user?.user_name}
        />
      ) : (
        <h2 style={textStyle ?? {}}>
          {user?.user_name?.[0] ?? user?.name?.[0]}
          {user?.last_name?.[0]}
        </h2>
      )}
    </div>
  );
}
